import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  num: '01',
  title: 'Kit Domingo Sin Nudo',
  desc: 'Reset nervioso en 10 minutos para bajar la activación después de cada encuentro familiar. Semáforo somático, protocolos de corte de campo y descarga física. Para los domingos y los días después.',
  value: '$8.000'
}, {
  num: '02',
  title: 'Guión de Límites Elegantes',
  desc: 'Scripts listos para poner límites sin culpa, sin pelea y sin explicaciones. Framework de límite en 3 capas. Respuestas preparadas para cada tipo de manipulación familiar. Para tener a mano.',
  value: '$10.000'
}, {
  num: '03',
  title: 'Mapa Relámpago del Árbol',
  desc: 'Plantillas visuales para mapear tu árbol genealógico en 30 minutos. Leyenda de símbolos, mapas de dinero y amor, casos ejemplo y resumen de patrones. Sin formación previa necesaria.',
  value: '$9.000'
}, {
  num: '04',
  title: 'Manual Anti-Culpa',
  desc: 'La diferencia entre culpa sistémica y culpa genuina. Los 4 tipos de culpa que heredan las mujeres del linaje. Algoritmo anti-culpa, frases puente y plan de acción de 7 días. Tu guía de consulta rápida.',
  value: '$8.000'
}, {
  num: '05',
  title: 'Banco de Scripts: Cartas que Sanan',
  desc: 'Cartas modelo para escribirle a tu madre, a tu padre y a tu linaje. Plantilla en 5 partes, frases de apertura y cierre, y checklist post-carta. Para cuando las palabras no salen solas.',
  value: '$9.000'
}, {
  num: '06',
  title: 'Planner 21 Días: Nueva Matriarca',
  desc: 'Tu acompañamiento diario durante las tres primeras semanas de integración. Microacciones diarias, trackers por tomo y ritual de mini-coronación al cierre. Para pasar de entender a vivir el cambio.',
  value: '$9.000'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#2D1B1B] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10 relative overflow-hidden" data-id="element-19">
      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-20">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-21">
          <h2 className="text-3xl md:text-5xl font-bold text-[#F5ECD7] mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-22">
            🎁 6 BONOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-23">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-[#1C1410] border border-[#C9A96E]/20 rounded-xl p-5 flex flex-col h-full shadow-lg" data-id="element-24">
              <div className="flex items-center gap-3 mb-3" data-id="element-25">
                <span className="text-[#C4856A] font-bold text-xl" data-id="element-26">
                  {bonus.num}
                </span>
                <div className="inline-flex bg-gradient-to-r from-[#C9A96E] to-[#C4856A] text-[#1C1410] text-[10px] font-bold px-2.5 py-1 rounded-full uppercase" data-id="element-27">
                  🎁 BONO {idx + 1}
                </div>
              </div>
              <h3 className="text-lg font-bold text-[#F5ECD7] mb-2" data-id="element-28">
                {bonus.title}
              </h3>
              <p className="text-[#FAF3E8] text-sm leading-relaxed mb-4 flex-grow" data-id="element-29">
                {bonus.desc}
              </p>
              <div className="flex items-center justify-between border-t border-[#C9A96E]/10 pt-3 mt-auto" data-id="element-30">
                <span className="text-[#D4A5A5] text-xs line-through decoration-[#8B2635]/50" data-id="element-31">
                  {bonus.value}
                </span>
                <span className="text-[#C9A96E] font-bold text-sm uppercase tracking-wider" data-id="element-32">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-33">
          <p className="text-xl md:text-2xl text-[#F5ECD7] font-bold" data-id="element-34">
            Valor total bonos:{' '}
            <span className="text-[#D4A5A5] line-through" data-id="element-35">$53.000</span>{' '}
            <span className="text-[#C9A96E]" data-id="element-36">→ GRATIS con tu Código</span>
          </p>
        </div>
      </div>
    </section>;
}